"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Maybe = void 0;
const Effect_1 = require("./Effect");
const emit_1 = require("../tools/emit");
const tail_1 = require("../tools/tail");
const isJust = (a) => a._tag === 'just';
class Maybe extends Effect_1.Effect {
    constructor(a) {
        super();
        this.fmap = (f) => Maybe.fmap(f, this);
        this.bind = (f) => Maybe.bind(f, this);
        this.identity = () => Maybe;
        this.isValide = () => Maybe.isJust(this);
        this._open = () => this.record;
        this.isJust = () => Maybe.isJust(this);
        this.isNothing = () => Maybe.isNothing(this);
        this.fromJust = () => Maybe.fromJust(this);
        this.fromMaybe = (d) => Maybe.fromMaybe(d, this);
        this.maybeToList = () => Maybe.maybeToList(this);
        this.case = (f, n) => Maybe.case(this, f, n);
        this.record = a;
    }
}
exports.Maybe = Maybe;
_a = Maybe;
Maybe.fmap = (f, a) => isJust(a.record) ? Maybe.from(f(a.record.value)) : Maybe.nothing;
Maybe.bind = (f, a) => isJust(a.record) ? f(a.record.value) : Maybe.nothing;
Maybe.from = (a) => a instanceof Maybe && a.record._tag === 'nothing' || a === null || a === undefined ? Maybe.nothing : Maybe.just(a);
Maybe.lift = (f) => (a) => Maybe.fmap(f, a);
Maybe.just = (a) => new Maybe({ _tag: 'just', value: a });
Maybe.nothing = new Maybe({ _tag: 'nothing' });
Maybe.isJust = (a) => a.record._tag === 'just';
Maybe.isNothing = (a) => a.record._tag === 'nothing';
Maybe.fromJust = (a) => isJust(a.record) ? a.record.value : (0, emit_1.emit)("Error: Maybe opened on nothing");
Maybe.fromMaybe = (d, a) => isJust(a.record) ? a.record.value : d;
Maybe.listToMaybe = (a) => a.length === 0 ? Maybe.nothing : Maybe.just(a[0]);
Maybe.maybeToList = (a) => isJust(a.record) ? [a.record.value] : [];
Maybe.catMaybes = (a) => [
    ...(a.length && isJust(a[0].record) ? [a[0].record.value] : []),
    ...(a.length ? Maybe.catMaybes((0, tail_1.tail)(a)) : [])
];
Maybe.mapMaybe = (f, a) => [
    ...(a.length ? Maybe.maybeToList(f(a[0])) : []),
    ...(a.length ? Maybe.mapMaybe(f, (0, tail_1.tail)(a)) : [])
];
Maybe.liftFromThrowable = (f) => (...a) => {
    try {
        return Maybe.just(f(...a));
    }
    catch (_b) {
        return Maybe.nothing;
    }
};
Maybe.liftFromThrowableAsync = (f) => (...a) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return Maybe.just(yield f(...a));
    }
    catch (_b) {
        return Maybe.nothing;
    }
});
Maybe.case = (a, f, n) => isJust(a.record) ? f(a.record.value) : n();
//# sourceMappingURL=Maybe.js.map